var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUnder516Ccebb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52553",
    "data-name": "Group 52553",
    transform: "translate(-1232 -8245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21922",
    "data-name": "Rectangle 21922",
    transform: "translate(1232 8245)",
    fill: "#fff",
    stroke: "#d7d9e2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 39,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52552",
    "data-name": "Group 52552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21923",
    "data-name": "Rectangle 21923",
    transform: "translate(1263 8263)",
    fill: "#fff",
    stroke: "#007aff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 15,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21924",
    "data-name": "Rectangle 21924",
    width: 25,
    height: 6,
    rx: 3,
    transform: "translate(1270 8252)",
    fill: "#d7d9e2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnder516Ccebb);
export default __webpack_public_path__ + "static/media/logo-under.516ccebb.194a3745ab3e23803d0481d0361e0cb7.svg";
export { ForwardRef as ReactComponent };